import React, { Component } from 'react'
import { combineNames } from '../FamilyReferrals/FamilyReferralHelpers.jsx'
import Modal from '../../components/Modal/Modal'
import YSpinner from '../../elements/Spinner/Spinner'
import { parentQuestionnaire, pqConvert, family_products_services } from './FamilyFormHelpers'
import { saveSubAcf2DB } from '../Tree/Utils'
import { DevBuild, DemoBuild, GetFormsEPmbo, GetFormsEPmbo2 } from '../../variables/Config'

// Display sing form item on screen
class Formi extends Component {
    constructor(props) {
        super(props)
        this._isMounted = false;

        this.state = { 
            showme: false, 
            restError:"",
            isLoading: false,
            cpt: {}, 
            filter: "" 
        }
        //this.handleHide = this.handleHide.bind(this)
        //this.handleShow = this.handleShow.bind(this)
        //this.inUpdate = this.inUpdate.bind(this)
        //this.onSaveTable = this.onSaveTable.bind(this)
    }
    inUpdate = (onOff) => {
        //console.log("inUpdate =", onOff)
        if (this._isMounted)
            this.setState({isUpdating:onOff})
    }
    /*
    familyFetch(url){
        fetch(url ,{headers: {'Accept-Encoding' : 'gzip'}} )
       // fetch(url)
            .then(response => {
                if (response.ok) {
                    if (!this._isMounted) return null
                    return response.json()
                } else
                    throw new Error('familyFetch: Something went wrong ... ')
            })
            .then(cpt => {
                if (!this._isMounted) return null
                this.setState({ cpt, isLoading: false })
                return cpt; // void - no one is looking...
            })
            .then(res => {
                console.log("familyfetch = ", res)
                return res
            })
            .catch(restError => this.setState({ restError: restError, isLoading: false }))
    }
    componentDidMount(){ // add constructor..
        this._isMounted = true
    }
    componentWillUnmount(){ 
        this._isMounted = false
    }
    */
    onSaveTable = (ev, data) => {
        ev.preventDefault()
        console.log(data)
        // locate parent ID & veriffy name & family 
        //        this.newFetch("https://t.digma.me/wp-json/mbo/v3/leadforms") 
        //this.familyFetch("https://t.digma.me/wp-json/wp/v2/digma_families/" + data.family_code.value + "?fields=id,title,acf")
        
        //console.log("Formi onSaveTable code="+ data.family_code.value + "family=" , this.state.cpt)
        
        // look at this.state.cpt['family_members']
        // determine pre/post
        let subTableId = ""
        let pq = ""
        if (data.form_name.value === "שאלון עמדות להורה") {
            if (data.program_status.value === "תחילת התוכנית") // pre
                subTableId = "questionnaire_pre"
            else if (data.program_status.value === "סיום התוכנית") // post
                subTableId = "questionnaire_post"
            else return console.log("onsave leadforms - ERROR")
            // assuming end user form version v2
            pq = parentQuestionnaire  // "family_products_services":
              
            Object.keys(parentQuestionnaire).map(item => {
                if (data[item] === undefined){ // some manual mapping
                    if (item === "id")
                        return pq[item] = data['form_format'].value // keep format version in id
                    if(item === "interviewer") 
                        return pq[item] = data['first_name'].value
                    console.log("Forms onSaveTable/parentq pre/post?? undefined item="+item)
                    return null
                }
                if (pqConvert[data[item].value] !== undefined) // apply convert end user terminlogy to app terminology
                    return pq[item] = pqConvert[data[item].value]
                return pq[item] = data[item].value // value as is
            })
            console.log(pq)
            // test corectness
            // copy to component
            // use regular save table: save2DB(memberPostId, this.state.products, subTableId, "group" )
            // save2DB(data['family_code'].value, pq, subTableId, "group" ) calls saveSubAcf2DB
    
            //saveSubAcf2DB = (cptId, data, dataId, dataType, inUpdate, mbouser)
            let ps = data['parent_status'].value === "בן זוג" ? 2 : 1 // 1 is single or woman partner
            let parent_code = data['family_code'].value + ps
            saveSubAcf2DB(parent_code, pq, subTableId, "group", this.inUpdate, this.props.mbouser)
        } else if (data.form_name.value === "שאלון מוצרים ושרותים"){
            if (data.program_status.value === "תחילת התוכנית") // same
                subTableId = "family_products_services"
            else if (data.program_status.value === "סיום התוכנית") // same
                subTableId = "family_products_services"
            else return console.log("ERROR")

            pq = family_products_services  // "family_products_services":
            Object.keys(family_products_services).map(item => {
                if (data[item] === undefined){ // some manual mapping
                    if (item === "id")
                        return pq[item] = data['form_format'].value // keep format version in id
                    if(item === "interviewer") 
                        return pq[item] = data['first_name'].value
                    console.log("Forms onSaveTable/parentq pre/post?? undefined item="+item)
                    return null
                }
                // no conversion needed
                //if (pqConvert[data[item].value] !== undefined) // apply convert end user terminlogy to app terminology
                //    return pq[item] = pqConvert[data[item].value]
                return pq[item] = data[item].value // value as is
            })

            console.log(pq)
            // test corectness
            // copy to component
            // use regular save table: save2DB(memberPostId, this.state.products, subTableId, "group" )
            // save2DB(data['family_code'].value, pq, subTableId, "group" ) calls saveSubAcf2DB
    
            //saveSubAcf2DB = (cptId, data, dataId, dataType, inUpdate, mbouser)
            let parent_code = data['family_code'].value 
            saveSubAcf2DB(parent_code, pq, subTableId, "group", this.inUpdate, this.props.mbouser)
        } else return console.log("ERROR - unknown form name=", data.form_name.value)
       
        alert("המידע עודכן במאגר")
    }
    handleShow = (ev) => {
        ev.preventDefault()
        this.setState({ showme: true })
    }
    handleHide = (ev) => {
        ev.preventDefault()
        this.setState({ showme: false })
    }
    valid_format_version = (form_name, form_format) =>{
        // lookup table
        if (form_name === "שאלון עמדות להורה" && form_format !== undefined)
            return form_format // "form_format_v1"
        if (form_name === "שאלון מוצרים ושרותים" && form_format !== undefined)
            return form_format // "form_format_v1"
        return false
    }
    render() {      
        const { referral, mykey, cptId, mbouser } = this.props
        let d = referral.form
        if (d.form_name === undefined || d.form_format === undefined)
            return (<div className="f-item">לא תקין- חסרות הגדרות-{cptId}</div>)
        if (d.form_format.id !== "form_format")
            return (<div className="f-item">לא תקין- גרסה לא מזוהה-{cptId}</div>)

        const form_name = d.form_name.value || d.form_name.title
        const form_format = this.valid_format_version(form_name, d.form_format.value)
        if (form_format !== "v3")
            return (<div className="f-item">טופס לא בפורמט V3 ,לא תקין-{cptId}</div>)
        if (d.family_name === undefined || d.parent_status === undefined || d.program_status === undefined)
            return (<div className="f-item">טופס בגרסה ישנה-{cptId}</div>)

        try { // try Error Boundary
            const first_name = d.first_name.value 
            const family = d.family_name.value 
            if (d.program_status === undefined){
                let msg = "mailto:mulli@site2goal.co.il?subject=טופס לא תקין "
                return (<div className="form-i"><a className="mail-link" href={msg + cptId+ ":" + mbouser.user_email}>טופס לא תקין-{cptId} - לשלוח למולי</a></div>)
            }
            const phase = d.program_status.value 
            const ps = d.parent_status.value

            const woman = (ps === 'בת זוג' || ps === 'חד הורית') ? first_name : ""
            const man   = (ps === 'בן זוג' || ps === 'חד הורי') ? first_name : ""

            if (this.state.showme){
                if (this.state.isLoading)
                    return (<YSpinner />)
                if (this.state.restError !== "")
                    return <h2>תקלה חולפת: {this.state.restError}</h2>
                return (
                    <Modal root={document.getElementById('modal-root')}>
                        
                        <button className="close-modal-button" onClick={this.handleHide}>סגור חלון טופס</button>
                        <div className="yahav-modal ext-form-title evenodd">
                            {<h2 className="sub-tab-title">{form_name}: <span className="bold-name">{family}&nbsp;{first_name}</span></h2>} 
                            <button type="button" style={{marginTop: '-1px'}} className="btn btn-success pull-left update-button" 
                                    onClick= {(event) => this.onSaveTable(event,referral.form)}>עדכון {form_name}&nbsp;{family}&nbsp;{first_name}</button>
                            <div id={'r-' + mykey} className="family-form-display modal family-form-inner ext-form">
                                {Object.keys(referral.form).map((item, index) => 
                                            <div key={index} className="f-item">
                                                <label className="form-label" >{referral.form[item]['title']}</label>
                                                <span className="form-value">{referral.form[item]['value']}</span>
                                            </div>
                                        )
                                }
                                    
                            </div>
                        </div>
                    </Modal>
                )
            } else {
                
                if (referral === undefined) {
                    console.log("Formi ERROR - form i  undfefined")
                    return (<div key={mykey} className="referral-i" onClick={this.handleShow}>undefined</div>)
                }

    // console.log("programi this.props", this.props)
                //let family = d.field_3.value //family
                let status = form_name + "-" + phase
                return (<div key={mykey} className="form-i" onClick={this.handleShow}>
                    { combineNames(family, woman, man, status)}&nbsp;&nbsp;{status} {/* status notsupported in combineNames so we add it */}
                </div>)
            }
        } catch(error){
            console.log(error)
            
            return <div key={mykey} className="form-i">משהו השתבש בטעינת הטופס כאן.:-( ניתן להמשיך לטפסים אחרים...</div>
            
        }
    }
}

class FamilyFormBody extends Component {
    constructor(props) {
        super(props)
        //const { mbouser } = this.props
        this._isMounted = false
        this.state = {
            rlist: [],
            filter: "",
            restError: "",
            isLoading: true
        }
        //this.filter = this.filter.bind(this)
    }
    newFetch = (url) => {
        fetch(url ,{headers: {'Accept-Encoding' : 'gzip'}} )
       // fetch(url)
            .then(response => {
                if (response.ok) {
                    if (!this._isMounted) return null
                    return response.json()
                } else
                    throw new Error('newFetch: Something went wrong ... ')
            })
            .then(rlist => {
                if (!this._isMounted) return null
                this.setState({ rlist, isLoading: false })
                return true; // void - no one is looking...
            })
            .catch(restError => this.setState({ restError: restError, isLoading: false }))
    }
    componentDidMount() {
        this._isMounted =true

        this.setState({modalRoot: document.getElementById('modal-root')})
        if (DemoBuild || DevBuild) // GetFormsEPmbo
            //this.newFetch(HostUrl + "/wp-json/mbo/v3/leadforms") 
            this.newFetch(GetFormsEPmbo()) 
        else
            //this.newFetch(HostUrl + "/wp-json/mbo/v3/leadforms2")
            this.newFetch(GetFormsEPmbo2()) 
 
        //this.newFetch("https://t.digma.me/wp-json/mbo/v3/leadforms") HostUrl
        //this.newFetch("http://digmame/wp-json/mbo/v3/families") //GetFamiliesInProgramNameListEPmbo
        //this.newFetch(GetFamiliesInProgramNameListEPmbo) //
    }
    componentWillUnmount(){
        this._isMounted = false
    }
    filter = (e) => {
        e.preventDefault()
        //this.setState({ filter: e.target.value, filterbystatus: "" })
        this.setState({ filter: e.target.value })
    }
    render() {
        const { isLoading, restError } = this.state
        if (isLoading)
            return (<YSpinner />)
        if (restError !== ""){
            alert(restError.message)
            return alert(restError.stack)
        }
        var rlist = this.state.rlist
        //if (rlist === undefined || )
        //    return  <h3>לא נמצאו טפסים</h3>

        if (this.state.filter) {
        //console.log("Filter items", items)
        rlist = rlist.filter(item => item.data.field_3.value.includes(this.state.filter) 
        //        || item.data.name.value.includes(this.state.filter) 
                || (item.data.field_54 !== undefined && item.data.field_54.value.includes(this.state.filter)) )
            //   || itemd.field_3.value.includes(this.state.filter) || item['m'].includes(this.state.filter))
        }
        return (
            <div id="main-win" className="yahav-modal">
                <h3 className="table-header">אינדקס טפסים ({rlist === "Fail to find digma forms" ? 0 : rlist.length})</h3>
        {/*<input id="filter-by-name" type="text" value={this.state.filter} 
        onChange={this.filter} placeholder="חיפוש לפי שם..." />*/}
                
                <div className="yahav-index-families-items">
                    {rlist === "Fail to find digma forms" ?  <h3>לא נמצאו טפסים</h3>
                       : rlist.length === 0 ? <h3>לא נמצאו טפסים, נסה/י חיפוש אחר</h3>
                        : rlist.map(item => {
                            ////console.log('RLIST item=', item)
                            if (item['pid'] === undefined)
                                return null
                            return <Formi key={item['pid']} cptId={item['pid']} 
                                                mykey={item['pid']} referral={item}
                                                mbouser={this.props.mbouser}  />
                        })
                    }
                </div>
            </div>
        )
    }
}
class FamilyFormsIndex extends React.PureComponent {
    render() {
        return (
            <div>
                <div id="modal-root"></div>
                <FamilyFormBody mbouser={this.props.mbouser} />
            </div>
        )
    }
}
export default FamilyFormsIndex;